// @core/api/endpoints/product/get_marketplace_metadata.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  MarketplaceMetadataResponse,
} from '../../../types/product';

const BASE_PATH = '/product';

/**
 * Get marketplace metadata
 * Retrieves marketplace listing information for a product including screenshots, ratings, and install counts.
 * @public This endpoint does not require authentication
 */
export async function GetMarketplaceMetadata(
  product_id: string,
  options?: RequestOptions
): Promise<MarketplaceMetadataResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/:product_id/marketplace`;
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = { ...options, skipAuth: true };
  return client.get<MarketplaceMetadataResponse>(requestPath, { ...requestOptions });
}
